import * as Types from '../actions/Types'

const INITIAL_STATE = {
  selected: null,
  isCreating: false,
  errorCreating: null,
  isDeleting: [],
  errorDeleting: false
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.CREATE_BOOKING:
      return {
        ...state,
        isCreating: [...state.isCreating, payload],
        errorCreating: null
      }
    case Types.CREATE_BOOKING_SUCCESS:
      return {
        ...state,
        isCreating: state.isCreating.filter(
          booking =>
            booking.laundryId.toString() !== payload.laundryId.toString() &&
            booking.timeId.toString() !== payload.timeId.toString() &&
            booking.date !== payload.date
        ),
        errorCreating: null
      }
    case Types.CREATE_BOOKING_FAILED:
      return {
        ...state,
        isCreating: state.isCreating.filter(
          booking =>
            booking.laundryId !== payload.data.laundryId &&
            booking.timeId !== payload.data.timeId &&
            booking.date !== payload.data.date
        ),
        errorCreating: payload.status
      }
    case Types.DELETE_BOOKING:
      return {
        ...state,
        isDeleting: [...state.isDeleting, payload],
        errorDeleting: false
      }
    case Types.DELETE_BOOKING_SUCCESS:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload.bookingId),
        errorDeleting: false
      }
    case Types.DELETE_BOOKING_FAILED:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload),
        errorDeleting: true
      }
    case Types.SHOW_UNBOOK_LAUNDRY_TIME_MODAL:
      return {
        ...state,
        selected: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/LaundryBookings.js